/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    photoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    ownerId: string;
}

/**
 * Check if a given object implements the UpdateOrganizationRequest interface.
 */
export function instanceOfUpdateOrganizationRequest(value: object): value is UpdateOrganizationRequest {
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    return true;
}

export function UpdateOrganizationRequestFromJSON(json: any): UpdateOrganizationRequest {
    return UpdateOrganizationRequestFromJSONTyped(json, false);
}

export function UpdateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'ownerId': json['ownerId'],
    };
}

export function UpdateOrganizationRequestToJSON(json: any): UpdateOrganizationRequest {
    return UpdateOrganizationRequestToJSONTyped(json, false);
}

export function UpdateOrganizationRequestToJSONTyped(value?: UpdateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'currency': value['currency'],
        'address': value['address'],
        'phone': value['phone'],
        'email': value['email'],
        'photoURL': value['photoURL'],
        'ownerId': value['ownerId'],
    };
}

